import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";
import {v4 as uuidv4} from 'uuid';

import { FONT } from "../../../value/staticValues";
import { ERROR_CODE } from "../../../value/type";
import { PLATFORM_URL } from "../../../value/Url";
import { base64Encoding, getCurrentTimestamp, getTimestampToDate } from "../../../common/util";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomSquareCheckBox } from "../../base/CustomCheckBox";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { VolumeData, guestOsDropdownItem, imageFormatDropdownItem } from "./VolumeData";

interface ArgsType {
    volumeId: string,
    volumeName: string
}

interface VolumeVmImageUploadProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: VolumeData,
};

VolumeVmImageUpload.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function VolumeVmImageUpload(props:VolumeVmImageUploadProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUploadYn, setExecuteUploadYn] = useState(false);
    const [vmImageName, setVmImageName] = useState("");
    const [vmImageDesc, setVmImageDesc] = useState("");
    const [vmImageFormatTypeCode, setVmImageFormatTypeCode] = useState("QCOW");
    const [shareTypeCode, setShareTypeCode] = useState("PUB");
    const [osTypeCode, setOsTypeCode] = useState("NONE");

    const [targetId, setTargetId] = useState("");

    const [domainList, setDomainList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);

    const [vmImageNameWarnYn, setVmImageNameWarnYn] = useState(false);


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkVmImageData();
                if(successYn) {
                    setExecuteUploadYn(true);
                }
            }

        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeUploadYn) {
            executeUpload();
        }
    }, [executeUploadYn]);


    useEffect(() => {
        if(shareTypeCode == "DM") {
            loadDomainList()
        } else if(shareTypeCode == "PRJ") {
            loadProjectList()
        }
    }, [shareTypeCode])



    function loadDomainList() {
        requests.get(PLATFORM_URL.DOMAIN)
        .then((response) => {
            setDomainList(response.data.map((data, index) => {
                return { value: data.dm_id, label: data.dm_nm };
            }));
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT)
        .then((response) => {
            setProjectList(response.data.map((data, index) => {
                return { value: data.prj_id, label: data.prj_nm };
            }));
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    function checkVmImageData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setVmImageNameWarnYn(false);

        let message = "";
        let error = false;
        if(!vmImageName) {
            message = t("MESSAGE_VM_IMAGE_INFO_ENTER_ERROR_MESSAGE")
            setVmImageNameWarnYn(true);
            error = true;
        }
        else if (!vmImageFormatTypeCode || !osTypeCode) {
            message = t("MESSAGE_VM_IMAGE_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }


        if(error == true) {
            executeResult({}, false, message);
        }
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteUploadYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function executeUpload() {

        const body = {
            volume: {
                volume_id: props.args?.volume_id
            },
            vm_image: {
                vm_image_name: vmImageName,
                vm_image_description: vmImageDesc,
                vm_image_format_type_code: vmImageFormatTypeCode,
                share_type_code: shareTypeCode,
                os_type_code: osTypeCode,
            }
        }

        requests.post(PLATFORM_URL.VOLUME + '/' + props.args?.volume_id + '/uploadimage', body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VOLUME_VM_IMAGE_UPLOAD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {

            if (error.status == 400) {
                executeResult({successYn: false}, false, t("VM_VOLUME_INVALUD_VOLUME"));
            } else if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VOLUME_VM_IMAGE_UPLOAD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }
    function selectButton(id, type){
        setShareTypeCode(type);
    }
    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("MESSAGE_VOLUME_SNAPSHOT_VM_IMAGE_UPLOAD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("VN_IMAGE_NAME_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={vmImageName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageName}
                                warnYn={vmImageNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={3}
                                width={570}
                                height={100}
                                value={vmImageDesc}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("IMAGE_FILE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("FOTMAT_TYPE_TEXT")}
                            </Text>
                            <CustomDropDown
                                key={5}
                                width={300} height={36}
                                items={imageFormatDropdownItem}
                                setValue={setVmImageFormatTypeCode}
                                disable={false}
                                defaultvalue={{value: "QCOW", label: "QCOW2"}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("GUEST_OS_TEXT")}
                            </Text>
                            <CustomDropDown
                                key={5}
                                width={300} height={36}
                                items={guestOsDropdownItem}
                                setValue={setOsTypeCode}
                                disable={false}
                                defaultvalue={{value: "NONE", label: t("EMPTY_TEXT")}}
                            />
                        </View>
                    </View>
                    {
                        /*
                    <Text style={style.titleText}>{
                        t("SHARE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SHARE_CATEGORY_TEXT")}
                            </Text>
                            <CustomRadioBtn
                                id={"VmImageShareType"}
                                type={"PUB"}
                                size={18}
                                checked={shareTypeCode === "PUB" ? true: false}
                                selectCb={selectButton}
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn
                                id={"VmImageShareType"}
                                type={"DM"}
                                size={18}
                                checked={shareTypeCode === "DM" ? true: false}
                                selectCb={selectButton}
                                label={"도메인"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn
                                id={"VmImageShareType"}
                                type={"PRJ"}
                                size={18}
                                checked={shareTypeCode === "PRJ" ? true: false}
                                selectCb={selectButton}
                                label={"개인(프로젝트)"}
                                labelStyle={labelStyle}
                            />
                        </View>
                        {
                            shareTypeCode != "PUB" ?
                            <View style={style.rowContainer}>

                                <Text style={style.columnText}>
                                    {shareTypeCode == "DM" ? t("DOMAIN_INFO_TEXT") : t("PROJECT_INFO_TEXT")}
                                </Text>

                                <CustomDropDown
                                    key={10}
                                    width={300} height={36}
                                    items={shareTypeCode == "DM" ? domainList : projectList}
                                    setValue={setTargetId}
                                    disable={false}
                                    defaultvalue={{label:"", value:""}}
                                />
                            </View>
                            : null
                        }
                    </View>
                        */
                    }
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}